import ReplyMessage from "./ReplyMessage.js";
import SendButton from "./SendButton.js";
import pfp from "./pfp.js";
import config from "../../../config.js";

const InputArea = ({
  chatBarHeight,
  replyToPadding,
  userInfo,
  replyingTo,
  getInputProps,
  textareaRef,
  message,
  setMessage,
  isEditingMessage,
  setIsEditingMessage,
  setIdToEdit,
  handleSaveEditedMessage,
  createNewMessage,
  resetMessage,
  incrementUnreadMessages,
  messageFiles,
  uploadFileViaButton,
  documentPreviewIcon,
  setMessageFiles,
}) => {
  const validPreviewExtensions = config.VALID_PREVIEW_EXTENSIONS;

  return (
    <div
      style={{
        background: "white",
        height: "184px",
        paddingTop: "0.1px",
        width: "900px",
        transform: "translateY(3px) translateX(-20px)",
      }}
    >
      <div
        style={{
          marginTop: "32px",
          marginLeft: "64px",
          minWidth: "850px",
          maxWidth: "900px",
          position: "absolute",
          bottom: "0",
          height: `${chatBarHeight + replyToPadding ?? 0}px`,
          minHeight: "152px",
          pointerEvents: "auto",
          transform: "translateX(20px)",
        }}
        className="send-chatbar"
      >
        <div
          style={{
            position: "absolute",
            transform: "translateX(-83px) translateY(-20px)",
          }}
        >
          {pfp(userInfo?.pfp, 20, true)}
        </div>

        <ReplyMessage
          replyingTo={replyingTo}
          userInfo={userInfo}
          validPreviewExtensions={validPreviewExtensions}
          documentPreviewIcon={documentPreviewIcon}
        />

        <div className="align-items-center d-flex">
          <input {...getInputProps()} />
          <textarea
            ref={textareaRef}
            rows="1"
            value={message}
            placeholder="Start typing your message here...."
            id="msgcontent"
            name="msgcontent"
            className="chatbox-input"
            onChange={(e) => {
              if (e.target.value.length < 1000) {
                setMessage(e.target.value);
              }
            }}
            onKeyDown={async (e) => {
              if (
                e.key === "Enter" &&
                !e.shiftKey &&
                (message || messageFiles.length !== 0)
              ) {
                e.preventDefault();
                if (isEditingMessage) {
                  setIsEditingMessage(false);
                  setIdToEdit(null);
                  setMessage("");
                  handleSaveEditedMessage();
                } else {
                  await createNewMessage();
                  resetMessage();
                  incrementUnreadMessages();
                }
              }
            }}
          />
        </div>
        <SendButton
          isEditingMessage={isEditingMessage}
          setIsEditingMessage={setIsEditingMessage}
          setIdToEdit={setIdToEdit}
          setMessage={setMessage}
          handleSaveEditedMessage={handleSaveEditedMessage}
          createNewMessage={createNewMessage}
          resetMessage={resetMessage}
          incrementUnreadMessages={incrementUnreadMessages}
          message={message}
          messageFiles={messageFiles}
          replyingTo={replyingTo}
          uploadFileViaButton={uploadFileViaButton}
          validPreviewExtensions={validPreviewExtensions}
          documentPreviewIcon={documentPreviewIcon}
          setMessageFiles={setMessageFiles}
        />
      </div>
    </div>
  );
};

export default InputArea;
